import { Dialog, Modal, ModalOverlay } from "react-aria-components";

interface LightboxProps {
  url: string | null;
  alt?: string;
  // Optional caption rendered as a code chip below the image. Used by the
  // gallery to show which ordering key a photo belongs to.
  caption?: string | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

// Shared full-screen photo viewer. Renders nothing when url is null so the
// caller can keep the latest URL state without forcing a remount/race.
export const Lightbox: React.FC<LightboxProps> = ({ url, alt, caption, isOpen, onOpenChange }) => (
  <ModalOverlay
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    isDismissable
    className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-8"
  >
    <Modal className="max-h-full max-w-full outline-none">
      <Dialog
        className="flex flex-col items-center gap-3 outline-none"
        aria-label="Full-size photo"
      >
        {url && (
          <img
            src={url}
            alt={alt ?? ""}
            className="max-h-[80vh] max-w-[92vw] rounded-lg bg-white object-contain shadow-2xl"
          />
        )}
        {caption && (
          <div className="max-w-[92vw] rounded-md bg-white/95 px-3 py-1.5 font-mono text-sm text-gray-900 shadow-lg">
            {caption}
          </div>
        )}
      </Dialog>
    </Modal>
  </ModalOverlay>
);
